<template>
  <v-list-item>
    <v-list-item-icon>
      <v-icon>mdi-settings</v-icon>
    </v-list-item-icon>
    <v-list-item-title>
      Settings
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: 'TheNavigationDrawerSettings',
};
</script>
